/** Shared category labels + where guides appear on the public site (tourist + admin). */

export const GUIDE_CATEGORY_META = {
	visa: { label: 'Visa & immigration', hub: '/visa', hubLabel: 'Visa hub' },
	government: { label: 'Government & permits', hub: '/government', hubLabel: 'Government hub' },
	transportation: { label: 'Transportation', hub: '/transportation', hubLabel: 'Transport hub' },
	living_in_nepal: { label: 'Living in Nepal', hub: '/living-in-nepal', hubLabel: 'Living in Nepal hub' },
	seasonal: { label: 'Seasons & weather', hub: '/seasonal-discovery', hubLabel: 'Seasonal hub' },
	festival: { label: 'Festivals', hub: '/festivals', hubLabel: 'Festivals hub' },
	trends: { label: 'Travel trends', hub: '/travel-trends', hubLabel: 'Trends hub' },
	arrival: { label: 'Airport arrival', hub: '/arrival', hubLabel: 'Arrival hub' },
	trekking: { label: 'Trekking', hub: '/trekking', hubLabel: 'Trekking hub' },
	temples: { label: 'Temples & culture', hub: '/temples', hubLabel: 'Temples hub' },
	shopping: { label: 'Shopping', hub: '/shopping', hubLabel: 'Shopping hub' },
	safety: { label: 'Safety', hub: '/safety', hubLabel: 'Safety hub' },
	insurance: { label: 'Travel insurance', hub: '/plan/insurance', hubLabel: 'Insurance planner' },
	packing: { label: 'Packing', hub: '/plan/packing', hubLabel: 'Packing planner' },
	food: { label: 'Food & dining', hub: '/living-in-nepal', hubLabel: 'Living in Nepal hub' },
	sim: { label: 'SIM & connectivity', hub: '/living-in-nepal', hubLabel: 'Living in Nepal hub' },
	money: { label: 'Money & payments', hub: '/living-in-nepal', hubLabel: 'Living in Nepal hub' },
	emergency: { label: 'Emergency', hub: '/safety', hubLabel: 'Safety hub' },
	culture: { label: 'Culture', hub: '/temples', hubLabel: 'Temples hub' },
	etiquette: { label: 'Etiquette', hub: '/temples', hubLabel: 'Temples hub' },
	permits: { label: 'Permits', hub: '/government', hubLabel: 'Government hub' },
	internet: { label: 'Internet & wifi', hub: '/living-in-nepal', hubLabel: 'Living in Nepal hub' },
	health: { label: 'Health', hub: '/safety', hubLabel: 'Safety hub' },
};

export const GUIDES_INDEX_PATH = '/guides';

export function getGuideCategoryLabel(category) {
	return GUIDE_CATEGORY_META[category]?.label || (category || '').replace(/_/g, ' ');
}

export function getGuidePublicPath(slug) {
	return `${GUIDES_INDEX_PATH}/${slug}`;
}

/** Where a published guide is listed on the public site (for admin clarity). */
export function getGuideVisibility(category) {
	const meta = GUIDE_CATEGORY_META[category] || {};
	const locations = [
		{ label: 'Travel Guide directory', path: GUIDES_INDEX_PATH },
	];
	if (meta.hub) {
		locations.push({ label: meta.hubLabel || meta.label, path: meta.hub });
	}
	locations.push({ label: 'Direct article link', path: null });
	return {
		categoryLabel: getGuideCategoryLabel(category),
		hub: meta.hub,
		locations,
	};
}

export function groupGuidesByCategory(guides) {
	const groups = {};
	(guides || []).forEach((g) => {
		const key = g.category || 'other';
		if (!groups[key]) groups[key] = [];
		groups[key].push(g);
	});
	return Object.keys(groups)
		.sort((a, b) => getGuideCategoryLabel(a).localeCompare(getGuideCategoryLabel(b)))
		.map((key) => ({
			category: key,
			label: getGuideCategoryLabel(key),
			hub: GUIDE_CATEGORY_META[key]?.hub,
			guides: groups[key].sort((a, b) => (a.title || '').localeCompare(b.title || '')),
		}));
}
